import { mapGetters } from 'vuex'

export var currencyMixin = {
  computed: {
    ...mapGetters({
      getCurrencies: 'systemModule/getSystemCurrencies',
    }),
  },
  methods: {
    getCurrencyLocation(currency) {
      if (currency) {
        let cifrao = currency.cifrao
        if (cifrao.toLowerCase() === 'r$') return 'BRL'
        else if (cifrao.toLowerCase() === 'u$') return 'USD'
        else if (cifrao.toLowerCase() === 'g$') return 'PYG'
        else if (cifrao.toLowerCase() === 'e$') return 'EUR'
        else if (cifrao.toLowerCase() === 'p$') return 'ARS'
        else return this.getCurrencyLocation(this.getCurrencies[0])
      } else {
        return 'BRL'
      }
    },
    getCurrencyFractionDigits(indiceMoeda = 0) {
      const listCurrencies = this.getCurrencies
      if (listCurrencies) {
        let moeda = listCurrencies[indiceMoeda]
        const pos = moeda.mascara.indexOf('.')
        if (pos !== -1)
          return moeda.mascara.substring(pos + 1, moeda.mascara.length).length
        else return 0
      }
    },
    formatCurrency(indiceMoeda = 0, value, style = 'currency') {
      const listCurrencies = this.getCurrencies
      if (value !== '' && listCurrencies) {
        let moeda = listCurrencies[indiceMoeda]
        return new Intl.NumberFormat('pt-BR', {
          style: style,
          currency: this.getCurrencyLocation(moeda),
          minimumFractionDigits: moeda
            ? this.getCurrencyFractionDigits(indiceMoeda)
            : 2,
        }).format(value)
      } else {
        return '0'
      }
    },
    formatDecimal(value, maxQntDecimal = 4, minQntDecimal = 2) {
      let retorno = new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
        maximumFractionDigits: maxQntDecimal,
        minimumFractionDigits: minQntDecimal,
      }).format(value)
      return retorno.replace(/[^0-9,]/g, '').replace(/,/, '.')
    },
  },
}
